{
  "inviteCodeError": "Код запрошення не знайдено",
  "genericError": "Ой, щось пішло не так: {{error}}",
  "pageTitle": "Додавання до програми за кодом: {{code}}"
}
